import React from "react";
import "../../App.css";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="section-container" style={{ marginTop: "50px" }}>
        <div className="footer-content">
          <div className="footer-left">
            <p>Discover a World of Possibilities with Zivoro.</p>
            <div className="social-links">
              <a
                href="https://www.facebook.com/share/fZFD4By6NpaUgbsu/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
              >
                <img src="/images/Facebook.svg" alt="Facebook" />
              </a>
              <a
                href="https://www.instagram.com/zivoro_ai?igsh=MTc4bnFjN3Ezemp4aw=="
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
              >
                <img src="/images/Instagram.svg" alt="Instagram" />
              </a>
              {/* <a
                  href="https://twitter.com/zivoro"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon"
                >
                  <img src="/images/Twitter.svg" alt="Twitter" />
                </a> */}
              <a
                href="https://www.linkedin.com/company/zivoro/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
              >
                <img src="/images/Linkedin.svg" alt="LinkedIn" />
              </a>
            </div>
            <p className="copyright">© 2024, All rights reserved.</p>
          </div>
          <div className="footer-right">
            <nav className="footer-nav">
              <a style={{ textAlign: "right" }} href="#products">
                Products
              </a>
              <a style={{ textAlign: "right" }} href="#excellence">
                About US
              </a>
              <a style={{ textAlign: "right" }} href="#contact">
                Contact US
              </a>
              <div className="footer-divider"></div>
              <div className="footer-bottom">
                <Link to="/privacy-policy">Privacy Policy</Link>
                <Link to="/terms-and-conditions">Terms and Conditions</Link>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
